import { DefaultGraphicService } from "./graphic-service";

import { GraphicCreator, GraphicService } from "../constants";

import { graphicCreator } from "../graphic-creator";

export function bindGraphicModules({bind: bind}) {
    bind(GraphicService).to(DefaultGraphicService), bind(GraphicCreator).toConstantValue(graphicCreator);
}

export default bindGraphicModules;
//# sourceMappingURL=graphic-module.js.map
